import React from "react";
import { Table, Card } from "antd";

interface TableOfMembersProps {
  members: string[];
  submitted: boolean;
}

export const TableOfMembers: React.FC<TableOfMembersProps> = ({
  members,
  submitted,
}) => {
  const columns = members.map((name, index) => ({
    title: name,
    dataIndex: `member${index}`,
    key: `member${index}`,
  }));

  const tableData = submitted
    ? members.map((_, index) => ({ [`member${index}`]: "" }))
    : [];

  return (
    <Card className="w-full shadow-sm rounded-2xl p-6 mt-4 mx-auto">
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        className="rounded-lg"
      />
    </Card>
  );
};
